<template>
  <div>
    <b-modal
      @ok="onCreateSupplier"
      @cancel="hideModal"
      no-close-on-backdrop
      ref="addSupplierModal"
      size="md"
      title="Add Supplier"
      centered
    >
      <b-row>
        <b-col>
          <b-row v-if="loading" class="d-flex justify-content-center">
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </b-row>
        </b-col>
      </b-row>
      <form-wrapper :validator="$v.supplier">
        <b-row>
          <b-col cols="6">
            <label>Name</label>

            <BaseInput v-model="supplier.name" name="name" />
          </b-col>
          <b-col cols="6">
            <label>Phone Number</label>
            <BaseInput v-model="supplier.phone" name="phone" type="number" />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12">
            <label>Note</label>

            <BaseInput v-model="supplier.note" name="remarks" type="textarea" />
          </b-col>
        </b-row>
      </form-wrapper>
      <div slot="modal-footer">
        <b-button
          variant="primary"
          type="submit"
          size="sm"
          @click="onCreateSupplier"
        >
          OK
        </b-button>
        <b-button
          variant="secondary"
          class="ml-2"
          type="submit"
          size="sm"
          @click="hideModal"
        >
          Cancel
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
//components
import BaseInput from "@/components/base/Input";
import DropDown from "@/components/base/DropDown";
// Vuelidate validations
import { required } from "vuelidate/lib/validators";

export default {
  name: "Supplier",
  data: () => ({
    supplier: {
      name: "",
      phone: "",
      note: "",
    },
  }),

  validations: {
    supplier: {
      name: { required },
      phone: { required },
      note: { required },
    },
  },

  components: {
    BaseInput,
    DropDown,
  },
  methods: {
    fetchQuotations() {
      // this.loading = true;
      this.$store
        .dispatch("quotation/fetchQuotations", { query: this.query })
        .then((res) => {
          // this.loading = false;
        })
        .catch((err) => {
          // this.loading = false;
        });
    },
    onCreateSupplier() {
      if (this.isValid()) {
        this.loading = true;
        this.$store
          .dispatch("supplier/createSupplier", this.supplier)
          .then((res) => {
            this.loading = false;
            this.showToast("Supplier successfully created", "Success");
            this.supplier = {
              name: "",
              phone: "",
              note: "",
            };
            this.$v.$reset();
            this.hideModal();
          })
          .catch((err) => {
            this.loading = false;
            this.showToast("Supplier failed to create", "danger");
          });
      }
    },
    showModal() {
      this.supplier = {
        name: "",
        phone: "",
        note: "",
      };
      this.$refs["addSupplierModal"].show();
    },
    hideModal() {
      this.$refs["addSupplierModal"].hide();
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant,
        solid: true,
      });
    },

    isValid() {
      this.$v.$touch();
      let status = false;
      status = !this.$v.$invalid;
      if (status) {
        return true;
      }
      return false;
    },
  },
  props: {},

  computed: {},
};
</script>
<style></style>
